"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./charts/charts'));



//////////////////
// WEBPACK FOOTER
// ./~/ng2-charts/index.js
// module id = 575
// module chunks = 5